import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_zoom_in.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconZoomIn = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconZoomIn;
